import React from 'react';
import { CircularProgress } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme:any) =>
  createStyles({
    root:{
        textAlign:"center",
        margin:"3rem 1.4rem"
    },
    pleaseWaitText:{
            fontSize:"#212121",
            color:"1.25rem",
            fontWeight:600
    },
    secondaryText:{

            fontSize:"1.0625rem",
            color:"#757575",
            fontWeight:400
    }
  }),
);

const ListLoading = ({secondaryText}:{
    secondaryText?:string
}) =>
{
const { t } = useTranslation();
const classes = useStyles();

    return <div className={classes.root}>
        <CircularProgress/>
        <p className={classes.pleaseWaitText}>{t("misc.pleaseWait")}</p>
        {secondaryText && <p className={classes.secondaryText}>{secondaryText}</p>}
        </div>
}

export default ListLoading;